/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	reactivation: {
		condition: async () => {
			const url = new URL(window.location.href);
			return url.searchParams.get('variant') === 'reactivation';
		},
		resolve: async () => await import('../_browser-expired-link-resend/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte'),
	},
};

export { pageConditions };
